module.exports = __webpack_public_path__ + "media/images/mobile/home/bg04-69a9d3b9dad58ae05bd6d00a325665b3.png";